module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAAA9BAMAAACpTdFYAAAAHlBMVEX///89ZZ8WR4sANYAaSY0nVJMvWpeMpMbR2+j///83EwnoAAAAA3RSTlPn+f1QqdauAAAASElEQVRIx2PgnIkEZhhDQeVMnGACw6iWUS2jWka1EKlFLA0JpMK0uKXhBIkMysYkAqNRLaNahokWMvLLaKE0qmVUy6gWmmkBAEWILxN9ONEsAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/fi.png
// module id = FBAN
// module chunks = 0